/* eslint-disable import/prefer-default-export */
export class SaldoMockProvider {
  pojos = [
    { fecha: '20/04/2021', concepto: '9996', importe: '0,01' },
    { fecha: '20/04/2021', concepto: '9996', importe: '2,95' },
    { fecha: '20/04/2021', concepto: '9996', importe: '1,19' },
    { fecha: '20/04/2021', concepto: '9996', importe: '0,55' },
    { fecha: '20/04/2021', concepto: '9996', importe: '1,69' },
    { fecha: '20/04/2021', concepto: '9996', importe: '2,75' },
    { fecha: '20/04/2021', concepto: '9996', importe: '1,79' },
    { fecha: '20/04/2021', concepto: '9996', importe: '0,12' },
    { fecha: '20/04/2021', concepto: '9996', importe: '4,20' },
    { fecha: '05/02/2021', concepto: '12345', importe: '5,00' },
    { fecha: '05/02/2021', concepto: '12345', importe: '5,00' },
    { fecha: '05/02/2021', concepto: '12345', importe: '5,00' },
    { fecha: '04/02/2021', concepto: '3177459', importe: '-0,05' },
    { fecha: '28/01/2021', concepto: '3177424', importe: '-0,30' },
    { fecha: '24/11/2020', concepto: '3176959', importe: '-2,00' },
    { fecha: '24/11/2020', concepto: '3176959', importe: '-3,93' },
    { fecha: '24/11/2020', concepto: '3176957', importe: '0,24' },
    { fecha: '24/11/2020', concepto: '3176957', importe: '-2,79' },
    { fecha: '07/07/2020', concepto: 'Juega y gana', importe: '1,00' },
    { fecha: '07/07/2020', concepto: 'Juega y gana', importe: '0,25' },
  ];

  getSaldoResponse = () => {
    const data = {
      error: false,
      pojos: this.pojos,
      pageNumber: 1,
      totalElements: 20,
      saldoUsuario: '30,32',
    };
    return data;
  };
}
